export default "__VITE_ASSET__DuOOOZuh__"